import { render, staticRenderFns } from "./ProductVariation.vue?vue&type=template&id=333b2e54"
import script from "./ProductVariation.vue?vue&type=script&lang=js"
export * from "./ProductVariation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports